import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import { prepareGlossaryData } from 'helpers/glossary';
import { glossary } from 'constants/glossary';
import memoize from 'fast-memoize';
import StyledReactTable from 'components/molecules/StyledReactTable';
import { get } from 'lodash';

class GlossaryTable extends Component {
    constructor(props) {
        super(props);
        this.glossaryTableInstance = React.createRef();
        this.prepareGlossaryData = memoize(prepareGlossaryData);
    }

    getColumns() {
        return [
            {
                Header: 'TERM',
                accessor: 'term',
                maxWidth: 200,
                style: {
                    'white-space': 'unset',
                    fontWeight: 'bold'
                }
            }, {
                Header: 'DEFINITION',
                accessor: 'definition',
                style: { 'white-space': 'unset' }
            }
        ];
    }

    render() {
        const userScope = get(this.props, 'currentUser.scope', []);
        const glossaryList = this.prepareGlossaryData(glossary, userScope);
        return (
            <Grid fluid>
                <StyledReactTable
                    data={glossaryList}
                    ref={this.glossaryTableInstance}
                    pageSize={glossaryList.length}
                    getTheadThProps={() => ({
                        style: {
                            backgroundColor: '#E2E2E2',
                        }
                    })}
                    columns={this.getColumns()}
                    defaultSorted={[{
                        id: 'term', desc: false
                    }]}
                    className="-highlight"
                    showPagination={false}
                />
            </Grid>
        );
    }
}

export default GlossaryTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/GlossaryTable.js